import type { OrderCalculatorApiResponse, OrderCalculatorPayload } from '../../typings'

export function calculatorOrderAction(payload: OrderCalculatorPayload): Promise<OrderCalculatorApiResponse> {
  const { api } = useApi()
  return api.post<OrderCalculatorApiResponse>('/v2/orders/calculator', payload)
}
